"use client";

import React, { lazy, Suspense, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaTrash, FaExternalLinkAlt } from "react-icons/fa";
import Header from "../../../components/header/header";
import TableTemplate from "../../../components/TableTemplate/TableTemplate";
import ComplexServiceAddPopup from "./ComplexServiceAddPopup";
import Pagination from "../../../components/Pagination/Pagination";
import { getAllComplexServices, deleteComplexService } from "../../../components/http";
import styles from "../../../components/TableTemplate/TableTemplate.module.scss";

const ComplexServices = () => {
  const { t } = useTranslation();
  const [complexServices, setComplexServices] = useState([]);
  const [isComplexServicePopupOpen, setIsComplexServicePopupOpen] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const limit = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const fetchComplexServices = async (page) => {
    setIsLoading(true);
    try {
      const offset = (page - 1) * limit;
      const response = await getAllComplexServices(limit, offset);
      setComplexServices(response.data);
      setTotalRecords(response.total_count);
    } catch (error) {
      console.error(t("complexService.list.errors.fetching"), error);
    }
    setIsLoading(false);
  };

  const handleDeleteComplexService = async (id) => {
    try {
      await deleteComplexService(id);
      alert(t("complexService.list.alerts.deletedSuccessfully"));
      fetchComplexServices(currentPage);
    } catch (error) {
      console.error(t("complexService.list.errors.deleting"), error);
      alert(t("complexService.list.alerts.deleteError"));
    }
  };

  const renderComplexServiceRow = (complexService) => {
    return (
      <>
        <div className={styles.cell} data-label={t("complexService.list.name")}>
          {complexService.name || t("complexService.list.notSpecified")}
        </div>
        <div className={styles.cell} data-label={t("complexService.list.description")}>
          {complexService.description || t("complexService.list.notSpecified")}
        </div>
      </>
    );
  };

  useEffect(() => {
    fetchComplexServices(currentPage);
  }, [currentPage]);

  return (
    <Suspense fallback={<div>{t("loading")}</div>}>
      <Header
        title={t("complexService.list.title")}
        onAddClick={() => setIsComplexServicePopupOpen(true)}
        showImportExport={false}
        onImportClick={null}
        onExportClick={null}
      />
      <TableTemplate
        headers={[
          t("complexService.list.name"),
          t("complexService.list.description"),
        ]}
        data={complexServices}
        renderRow={renderComplexServiceRow}
        title={t("complexService.list.title")}
        isLoading={isLoading}
      />
      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(totalRecords / limit)}
        onPageChange={(page) => setCurrentPage(page)}
      />
      <ComplexServiceAddPopup
        open={isComplexServicePopupOpen}
        onClose={() => setIsComplexServicePopupOpen(false)}
        onComplexServiceAdded={() => fetchComplexServices(currentPage)}
      />
    </Suspense>
  );
};

export default ComplexServices;
